import Swiper from 'swiper';

export default function carouselPartners() {

    $('.swiper-container:not(".gallery-img, .gallery-thumbs, .vehicle-image, .vehicle-thumbs, [data-slider-testimonials], [data-widget-homeslider-slider]")').each(function(index, element) {

        let $this = $(this),
            $carousel = $this.parents('.carousel-wrap').find('.swiper-slide');

        $this.addClass('instance-' + index);
        $this.parents('.carousel-wrap').find('.swiper-next-btn').addClass('swiper-next-btn-' + index);
        $this.parents('.carousel-wrap').find('.swiper-prev-btn').addClass('swiper-prev-btn-' + index);

        if ($(this).hasClass('partners-carousel')) {

            let mySwiper = new Swiper('.instance-' + index, {
                speed: 500,
                spaceBetween: 30,
                slidesPerView: 4,
                navigation: {
                    nextEl: '.swiper-next-btn-' + index,
                    prevEl: '.swiper-prev-btn-' + index
                },
                breakpoints: {
                    1023: {
                        slidesPerView: 'auto'
                    }
                }
            });


            if ($carousel.length <= 4 && window.innerWidth >= 1023) {
                mySwiper.destroy();
                $this.parents('.carousel-wrap').addClass('carousel-wrap--destroyed');
            }
            if ($carousel.length <= 3 && window.innerWidth <= 1023) {
                $this.parents('.carousel-wrap').addClass('carousel-wrap--mobile');
            }

            if (window.innerWidth <= 1023) {
                $this.parents('.carousel-wrap').removeClass('carousel-wrap--destroyed');
                mySwiper.init();
            }

            $(window).resize(function() {
                mySwiper.init();
            });

        }
    });
}